'use client';


import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Chatbot from '@/components/common/Chatbot';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import FAQSection from './components/FAQSection';
import { analytics } from '@/lib/analytics';

export default function ContactPage() {
  useEffect(() => {
    analytics.trackPageView('/contact');
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-24">
        {/* Page Header */}
        <div className="bg-gradient-to-br from-primary/5 to-secondary/5 py-12 border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
              Contact Us
            </h1>
            <p className="text-lg text-muted-foreground">
              We're here to help 24/7. Reach out via your preferred method.
            </p>
          </div>
        </div>

        {/* Contact Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid lg:grid-cols-3 gap-8 mb-12">
            {/* Left Column - Contact Form */}
            <div className="lg:col-span-2">
              <ContactForm />
            </div>

            {/* Right Column - Contact Info */}
            <div className="lg:col-span-1">
              <ContactInfo />
            </div>
          </div>

          {/* FAQ Section */}
          <FAQSection />
        </div>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}